import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { HttpApiService } from '@recruitee/http';
import { ID } from '@recruitee/ngrx';

import {
  RequisitionsFlowsUpdateBody,
  RequisitionFlowsResponse,
  RequisitionFlowResponse,
} from './flows.types';

@Injectable({ providedIn: 'root' })
export class RequisitionsFlowsHttpClient {
  constructor(protected httpApi: HttpApiService) {}

  public fetchCollection(): Observable<RequisitionFlowsResponse> {
    return this.httpApi.get('/requisitions/settings/approval_flows');
  }

  public create(body: RequisitionsFlowsUpdateBody): Observable<RequisitionFlowResponse> {
    return this.httpApi.post('/requisitions/settings/approval_flows', {}, body);
  }

  public update(id: ID, body: RequisitionsFlowsUpdateBody): Observable<RequisitionFlowResponse> {
    return this.httpApi.patch(`/requisitions/settings/approval_flows/${id}`, {}, body);
  }

  public delete(id: ID): Observable<RequisitionFlowResponse> {
    return this.httpApi.delete(`/requisitions/settings/approval_flows/${id}`);
  }
}
